import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#2563eb' }, // Blue
    secondary: { main: '#7c3aed' }, // Purple
    background: { default: '#f8fafc', paper: '#ffffff' },
    success: { main: '#22c55e' },
    error: { main: '#ef4444' },
    warning: { main: '#fbbf24' },
    text: { primary: '#1e293b' }
  },
  typography: {
    fontFamily: 'Inter, Roboto, Arial, sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    button: { fontWeight: 600 }
  }
});

export default theme;
